(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function formatTime(seconds) {
    if (!isFinite(seconds) || seconds < 0) return '0:00';
    var m = Math.floor(seconds / 60);
    var s = Math.floor(seconds % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  ready(function () {
    var rail = document.querySelector('[data-review-rail]');
    var prev = document.querySelector('[data-review-prev]');
    var next = document.querySelector('[data-review-next]');
    if (rail && prev && next) {
      var step = function () {
        var card = rail.querySelector('.ms-review');
        return card ? card.getBoundingClientRect().width + 16 : 320;
      };
      prev.addEventListener('click', function () {
        rail.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        rail.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    /* Photo → avatar compare slider (mobile) */
    var compare = document.querySelector('[data-ms-compare]');
    if (compare) {
      var frame = compare.querySelector('[data-ms-compare-frame]');
      var before = compare.querySelector('.ms-compare__before');
      var handle = compare.querySelector('[data-ms-compare-handle]');
      var range = compare.querySelector('[data-ms-compare-range]');
      var dragging = false;

      var setCompare = function (value) {
        var v = Math.max(0, Math.min(100, Number(value)));
        if (!isFinite(v)) v = 50;
        var pct = v + '%';
        if (before) before.style.width = pct;
        if (handle) handle.style.left = pct;
        if (frame) frame.style.setProperty('--ms-compare', String(v));
        if (range && String(range.value) !== String(Math.round(v))) {
          range.value = String(Math.round(v));
        }
      };

      var syncBeforeImageWidth = function () {
        if (!frame || !before) return;
        var img = before.querySelector('img');
        if (!img) return;
        img.style.width = frame.clientWidth + 'px';
        img.style.height = frame.clientHeight + 'px';
      };

      var updateFromClientX = function (clientX) {
        if (!frame) return;
        var rect = frame.getBoundingClientRect();
        if (!rect.width) return;
        setCompare(((clientX - rect.left) / rect.width) * 100);
      };

      var startDrag = function (clientX) {
        dragging = true;
        if (frame) frame.classList.add('is-dragging');
        updateFromClientX(clientX);
      };

      var moveDrag = function (clientX) {
        if (!dragging) return;
        updateFromClientX(clientX);
      };

      var endDrag = function () {
        dragging = false;
        if (frame) frame.classList.remove('is-dragging');
      };

      syncBeforeImageWidth();
      setCompare(range ? range.value : 50);
      if (typeof ResizeObserver !== 'undefined' && frame) {
        new ResizeObserver(syncBeforeImageWidth).observe(frame);
      } else {
        window.addEventListener('resize', syncBeforeImageWidth);
      }

      if (range) {
        range.addEventListener('input', function () {
          setCompare(range.value);
        });
      }

      if (frame) {
        frame.addEventListener('pointerdown', function (e) {
          if (e.button != null && e.button !== 0) return;
          startDrag(e.clientX);
          if (frame.setPointerCapture && e.pointerId != null) {
            try { frame.setPointerCapture(e.pointerId); } catch (err) {}
          }
          e.preventDefault();
        });
        frame.addEventListener('pointermove', function (e) {
          if (!dragging) return;
          moveDrag(e.clientX);
          e.preventDefault();
        });
        frame.addEventListener('pointerup', endDrag);
        frame.addEventListener('pointercancel', endDrag);

        // iOS Safari fallback
        frame.addEventListener('touchstart', function (e) {
          if (!e.touches || !e.touches.length) return;
          startDrag(e.touches[0].clientX);
          e.preventDefault();
        }, { passive: false });
        frame.addEventListener('touchmove', function (e) {
          if (!dragging || !e.touches || !e.touches.length) return;
          moveDrag(e.touches[0].clientX);
          e.preventDefault();
        }, { passive: false });
        frame.addEventListener('touchend', endDrag);
        frame.addEventListener('touchcancel', endDrag);
      }
    }

    var ugcButtons = document.querySelectorAll('[data-ugc-play]');
    ugcButtons.forEach(function (btn) {
      var video = btn.querySelector('video');
      var timeEl = btn.querySelector('[data-ugc-time]');
      if (!video) return;

      var setDuration = function () {
        if (timeEl && video.duration) timeEl.textContent = formatTime(video.duration);
      };
      video.addEventListener('loadedmetadata', setDuration);
      if (video.readyState >= 1) setDuration();

      btn.addEventListener('click', function () {
        ugcButtons.forEach(function (other) {
          if (other === btn) return;
          var otherVideo = other.querySelector('video');
          if (otherVideo) {
            otherVideo.pause();
            other.classList.remove('is-playing');
          }
        });

        if (video.paused) {
          video.muted = false;
          video.play().catch(function () {
            video.muted = true;
            return video.play();
          });
          btn.classList.add('is-playing');
          if (typeof window.msTrack === 'function') {
            window.msTrack('home_ugc_played', { index: Array.prototype.indexOf.call(ugcButtons, btn) });
          }
        } else {
          video.pause();
          btn.classList.remove('is-playing');
          if (typeof window.msTrack === 'function') {
            window.msTrack('home_ugc_paused', { index: Array.prototype.indexOf.call(ugcButtons, btn) });
          }
        }
      });

      video.addEventListener('ended', function () {
        btn.classList.remove('is-playing');
      });
    });
  });
})();
